<div [class]="['solid-background', 'display-flex']">
    <div class="display-flex flex-full">
        <input type="file" hidden="true" #fileElement (change)="onChange($event)" aria-hidden="true" tabindex="-1"
            aria-label="hidden file field" [multiple]="!!props?.multiple">
        <input type='text' matInput #fieldModel hidden='true' aria-hidden='true' [formControl]="formControl"
            [formlyAttributes]="field">
        <!-- This part is the left side (text and description)-->
        <div class="flex-2">
            @if (hasOptions) {
            <mat-form-field class="flex-full" [required]="props.required">
                <mat-label class="mutara-strong" color="primary">{{props.label}}</mat-label>
                <mat-select class="flex-2" [(value)]="currentSelect" [required]="props.required ?? false"
                    [formControl]="typeSelect" (selectionChange)="deleteFile()">
                    @for ( opt of lstOptions; track opt.value ) {
                    <mat-option [value]="opt?.value">
                        <span markdown>{{opt?.label}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            } @else {
            <div markdown [class]="['mutara-strong','flex-full']">{{props.label}}{{props.isRequired ? ' *' : ''}}</div>
            }
        </div>
        <div [class]="['flex-1']">
            <button #upload mat-flat-button
                [ngClass]="{'mutara-tb-pad': hasOptions,'mutara-button': true, 'centered': true, 'flex-full': true }"
                type='button' [color]=" disableButton ? 'accent' : 'primary'" (click)="triggerHiddenUploadClick()">
                <mat-label>{{fileNames.length == 0 ? ( !!hasOptions && !!disableButton ? 'Select Option' : 'Upload' ):
                    'Saved'}}</mat-label>
                <mat-icon>
                    {{disableButton ? 'lock' : 'upload_file'}}
                </mat-icon>
            </button>
            @if( fileNames.length > 0 ) {
            @for( fileName of fileNames; track fileName ) {
            <button [ariaLabel]="'Remove file '+ fileName" type='button' color='primary' matFab extended [class]="['mutara-sm-strong', 'micro-button']"
                (click)="deleteFile()">{{fileName}}<mat-icon>delete_outline</mat-icon></button>
            }
            }
            <br />
            <mat-hint class="mutara-sm-strong flex-full">File uploads must not exceed 200MB</mat-hint>
        </div>
    </div>
    <markdown [ngClass]="['flex-full']">{{props.description }}</markdown>
    @if (hasExtraFields) {
    <div class="display-flex">
        <formly-form [(model)]="childModel" [fields]="childFields" (modelChange)="_submitChildValues()"></formly-form>
    </div>
    }
</div>